import { render } from "./OrthoGard.vue?vue&type=template&id=783c610c&scoped=true"
import script from "./OrthoGard.vue?vue&type=script&lang=js"
export * from "./OrthoGard.vue?vue&type=script&lang=js"

import "./OrthoGard.vue?vue&type=style&index=0&id=783c610c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783c610c"]])

export default __exports__